import { extend, configure } from 'vee-validate';
import { email, min, max, length, required } from 'vee-validate/dist/rules';
import i18n from './i18n';

configure({
  // Special case for the variable _rule_,
  // eslint-disable-next-line
  defaultMessage: (field, values) => i18n.t(`validation.${values._rule_}`, values),
});

extend('email', email);
extend('length', length);
extend('max', max);
extend('min', min);
extend('required', required);
